import axios from 'axios'
import authHeader from './AuthHeader'
import { API_URL } from '../config/api'

class InvoicesService {

  // Get invoices list
  getInvoices = async (pageNum, search = '', limit = false, sortBy = 'name', sortOrder = 'asc', customerId = '') => {
    return await axios.get(API_URL + '/invoices?page=' + pageNum + '&search=' + search + '&limit=' + limit + '&sortBy=' + sortBy + '&sortOrder=' + sortOrder + '&customerId=' + customerId, { headers: authHeader() })
  }

  // Add new invoice
  addInvoice = async (invoice) => {
    return await axios.post(API_URL + '/invoices', invoice, { headers: authHeader() })
  }

  // Update invoice data
  updateInvoice = async (invoice, id) => {
    return await axios.patch(API_URL + '/invoices/' + id, invoice, { headers: authHeader() })
  }

  // Get invoice data
  getInvoice = async (id) => {
    return await axios.get(API_URL + '/invoices/' + id, { headers: authHeader() })
  }

  // Delete invoice
  deleteInvoice = async (id) => {
    return await axios.delete(API_URL + '/invoices/' + id, { headers: authHeader() })
  }

  // Get invoices chart dataset
  getInvoicesDataset = async ({ customerId = '', yearFrom = '', yearTo = '' }) => {
    // Crear una base de la URL
    let url = API_URL + '/dataset/invoices?'

    // Añadir parámetros opcionales si existen
    if (customerId) {
      url += `customerId=${customerId}&`
    }
    if (yearFrom) {
      url += `yearFrom=${yearFrom}&`
    }
    if (yearTo) {
      url += `yearTo=${yearTo}&`
    }

    // Eliminar el último '&' si lo hay
    url = url.endsWith('&') ? url.slice(0, -1) : url
    return await axios.get(url, { headers: authHeader() })
  }
}

export default new InvoicesService()